/** UI-only mock data for pharmacy workspace tabs */

export const MOCK_PRESCRIPTIONS = [
  {
    id: 'RX-2026-00142',
    patient_id: 'PAT-88421',
    patient_name: 'Rajesh Kumar',
    doctor_name: 'Dr. Meera Nair',
    ward: 'General Ward A',
    date: '2026-07-07',
    status: 'ACTIVE',
    priority: 'ROUTINE',
    item_count: 4,
    has_controlled: true,
    has_alerts: true,
  },
  {
    id: 'RX-2026-00138',
    patient_id: 'PAT-77210',
    patient_name: 'Anita Sharma',
    doctor_name: 'Dr. Vikram Singh',
    ward: 'ICU-2',
    date: '2026-07-07',
    status: 'ACTIVE',
    priority: 'URGENT',
    item_count: 6,
    has_controlled: false,
    has_alerts: false,
  },
  {
    id: 'RX-2026-00135',
    patient_id: 'PAT-66109',
    patient_name: 'Mohammed Farid',
    doctor_name: 'Dr. Priya Das',
    ward: 'Ortho Ward',
    date: '2026-07-06',
    status: 'PARTIALLY_DISPENSED',
    priority: 'ROUTINE',
    item_count: 3,
    has_controlled: true,
    has_alerts: true,
  },
  {
    id: 'RX-2026-00129',
    patient_id: 'PAT-55002',
    patient_name: 'Lakshmi Devi',
    doctor_name: 'Dr. Arjun Patel',
    ward: 'Maternity',
    date: '2026-07-06',
    status: 'ACTIVE',
    priority: 'ROUTINE',
    item_count: 5,
    has_controlled: false,
    has_alerts: false,
  },
];

/** Prescription line items keyed by prescription ID */
export const MOCK_PRESCRIPTION_ITEMS = {
  'RX-2026-00142': [
    { id: 'LI-1', medicine: 'Amoxicillin 500mg Capsule', dosage: '500mg', frequency: 'TDS', duration: '5 days', prescribed_qty: 15, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-2', medicine: 'Paracetamol 500mg Tablet', dosage: '500mg', frequency: 'SOS', duration: '3 days', prescribed_qty: 10, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-3', medicine: 'Morphine 10mg Injection', dosage: '10mg', frequency: 'BD', duration: '2 days', prescribed_qty: 4, dispensed_qty: 0, route: 'IV', controlled: true, schedule: 'H1' },
    { id: 'LI-4', medicine: 'Omeprazole 20mg Capsule', dosage: '20mg', frequency: 'OD', duration: '7 days', prescribed_qty: 7, dispensed_qty: 0, route: 'Oral', controlled: false },
  ],
  'RX-2026-00138': [
    { id: 'LI-5', medicine: 'Ceftriaxone 1g Injection', dosage: '1g', frequency: 'OD', duration: '5 days', prescribed_qty: 5, dispensed_qty: 0, route: 'IV', controlled: false },
    { id: 'LI-6', medicine: 'Normal Saline 500ml', dosage: '500ml', frequency: 'TDS', duration: '3 days', prescribed_qty: 9, dispensed_qty: 0, route: 'IV', controlled: false },
    { id: 'LI-7', medicine: 'Metformin 500mg Tablet', dosage: '500mg', frequency: 'BD', duration: '30 days', prescribed_qty: 60, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-8', medicine: 'Cetirizine 10mg Tablet', dosage: '10mg', frequency: 'OD', duration: '5 days', prescribed_qty: 5, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-9', medicine: 'Azithromycin 500mg Tablet', dosage: '500mg', frequency: 'OD', duration: '3 days', prescribed_qty: 3, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-10', medicine: 'Pantoprazole 40mg Tablet', dosage: '40mg', frequency: 'OD', duration: '7 days', prescribed_qty: 7, dispensed_qty: 0, route: 'Oral', controlled: false },
  ],
  'RX-2026-00135': [
    { id: 'LI-11', medicine: 'Tramadol 50mg Tablet', dosage: '50mg', frequency: 'BD', duration: '5 days', prescribed_qty: 10, dispensed_qty: 6, route: 'Oral', controlled: true, schedule: 'H' },
    { id: 'LI-12', medicine: 'Diclofenac 50mg Tablet', dosage: '50mg', frequency: 'BD', duration: '3 days', prescribed_qty: 6, dispensed_qty: 6, route: 'Oral', controlled: false },
    { id: 'LI-13', medicine: 'Calcium Carbonate 500mg', dosage: '500mg', frequency: 'OD', duration: '30 days', prescribed_qty: 30, dispensed_qty: 0, route: 'Oral', controlled: false },
  ],
  'RX-2026-00129': [
    { id: 'LI-14', medicine: 'Folic Acid 5mg Tablet', dosage: '5mg', frequency: 'OD', duration: '30 days', prescribed_qty: 30, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-15', medicine: 'Iron Fumarate 200mg', dosage: '200mg', frequency: 'OD', duration: '30 days', prescribed_qty: 30, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-16', medicine: 'Paracetamol 500mg Tablet', dosage: '500mg', frequency: 'SOS', duration: '5 days', prescribed_qty: 10, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-17', medicine: 'Multivitamin Capsule', dosage: '1 cap', frequency: 'OD', duration: '30 days', prescribed_qty: 30, dispensed_qty: 0, route: 'Oral', controlled: false },
    { id: 'LI-18', medicine: 'Vitamin D3 60k IU', dosage: '60k IU', frequency: 'Weekly', duration: '8 weeks', prescribed_qty: 8, dispensed_qty: 0, route: 'Oral', controlled: false },
  ],
};

export function getPrescriptionById(id) {
  return MOCK_PRESCRIPTIONS.find((r) => r.id === id) || null;
}

export function getPrescriptionItems(prescriptionId) {
  return MOCK_PRESCRIPTION_ITEMS[prescriptionId] || [];
}

export const MOCK_CONTROLLED_ITEMS = [
  { id: 'CQ-01', prescription_id: 'RX-2026-00142', medicine: 'Morphine 10mg Injection', schedule: 'H1', qty: 2, prescriber: 'Dr. Meera Nair', status: 'AWAITING_AUTHORIZATION', requested_at: '2026-07-07 09:15' },
  { id: 'CQ-02', prescription_id: 'RX-2026-00135', medicine: 'Tramadol 50mg Tablet', schedule: 'H', qty: 10, prescriber: 'Dr. Priya Das', status: 'AWAITING_AUTHORIZATION', requested_at: '2026-07-06 16:40' },
  { id: 'CQ-03', prescription_id: 'RX-2026-00142', medicine: 'Fentanyl 25mcg Patch', schedule: 'H1', qty: 1, prescriber: 'Dr. Meera Nair', status: 'AUTHORIZED', requested_at: '2026-07-07 08:00' },
];

export const MOCK_ALLERGIES = {
  'RX-2026-00142': [
    { id: 'A1', allergen: 'Penicillin', severity: 'SEVERE', reaction: 'Anaphylaxis', verified: true },
    { id: 'A2', allergen: 'Sulfa drugs', severity: 'MODERATE', reaction: 'Rash', verified: true },
  ],
  'RX-2026-00135': [
    { id: 'A3', allergen: 'Aspirin', severity: 'MILD', reaction: 'GI upset', verified: false },
  ],
  'RX-2026-00138': [],
  'RX-2026-00129': [],
};

export const MOCK_BILLS = [
  { id: 'BILL-8841', dispense_id: 'DISP-4421', patient_name: 'Rajesh Kumar', amount: 2840, payment_mode: 'Cash', date: '2026-07-07', status: 'POSTED' },
  { id: 'BILL-8836', dispense_id: 'DISP-4418', patient_name: 'Anita Sharma', amount: 1560, payment_mode: 'UPI', date: '2026-07-07', status: 'POSTED' },
  { id: 'BILL-8829', dispense_id: 'DISP-4410', patient_name: 'Walk-in Customer', amount: 420, payment_mode: 'Card', date: '2026-07-06', status: 'POSTED' },
  { id: 'BILL-8821', dispense_id: 'DISP-4402', patient_name: 'Mohammed Farid', amount: 3120, payment_mode: 'Insurance', date: '2026-07-06', status: 'REVERSED' },
];

export const MOCK_PRE_AUTH = [
  { id: 'PA-1201', dispense_id: 'DISP-4425', patient_name: 'Mohammed Farid', insurer: 'Star Health', amount: 8900, status: 'PENDING_INSURANCE', submitted_at: '2026-07-07 10:00' },
  { id: 'PA-1198', dispense_id: 'DISP-4419', patient_name: 'Lakshmi Devi', insurer: 'ICICI Lombard', amount: 4200, status: 'PENDING_INSURANCE', submitted_at: '2026-07-06 14:30' },
  { id: 'PA-1190', dispense_id: 'DISP-4408', patient_name: 'Rajesh Kumar', insurer: 'HDFC ERGO', amount: 15600, status: 'APPROVED', submitted_at: '2026-07-05 11:20' },
];

export const MOCK_WARD_RETURNS = [
  { id: 'WR-301', ward: 'ICU-2', medicine: 'Paracetamol 500mg', batch: 'BATCH-8821', qty: 20, raised_by: 'Nurse Priya', date: '2026-07-07', status: 'PENDING' },
  { id: 'WR-298', ward: 'General Ward A', medicine: 'Normal Saline 500ml', batch: 'BATCH-7710', qty: 4, raised_by: 'Nurse Amit', date: '2026-07-06', status: 'APPROVED' },
  { id: 'WR-295', ward: 'Ortho Ward', medicine: 'Ceftriaxone 1g', batch: 'BATCH-6602', qty: 2, raised_by: 'Nurse Sunita', date: '2026-07-06', status: 'COMPLETED' },
];

export const MOCK_MEDICINES = [
  { id: 'MED-001', name: 'Paracetamol 500mg Tablet', rate: 2.5, stock: 1200 },
  { id: 'MED-002', name: 'Amoxicillin 500mg Capsule', rate: 8.0, stock: 450 },
  { id: 'MED-003', name: 'Cetirizine 10mg Tablet', rate: 3.5, stock: 800 },
  { id: 'MED-004', name: 'Omeprazole 20mg Capsule', rate: 6.0, stock: 320 },
  { id: 'MED-005', name: 'Metformin 500mg Tablet', rate: 4.0, stock: 600 },
  { id: 'MED-006', name: 'Azithromycin 500mg Tablet', rate: 22.0, stock: 180 },
];
